import { ServiceAttachModel } from '@klant/conversational-connector/models/ServiceAttach.model';
import { ServiceAttach } from '@fp/interfaces/conversational/generated-async/model/service-attach';
import { AttachChannelResponse } from '@fp/interfaces/conversational/generated-async/model/attach-channel-response';
import { AttachChannelModel } from '@klant/conversational-connector/models/AttachChannel.model';
import { TypeModel } from '@klant/conversational-connector/models/Type.model';
import { StartConversationModel } from '@klant/conversational-connector/models/StartConversation.model';

import { Injectable } from '@angular/core';

/**
 * @module KlantConversationalModule
 * @ngdoc mapper-service
 * @name WebsocketMapper
 */
@Injectable({ providedIn: 'root' })
export class WebsocketMapper {
    public static mapServiceAttachToServiceAttachModel(serviceAttach: ServiceAttach): ServiceAttachModel {
        return {
            type: TypeModel.SERVICE_ATTACH,
            serviceName: serviceAttach.payload.service.name
        };
    }

    public static mapAttachChannelResponseToAttachChannelModel(attachChannelResponse: AttachChannelResponse): AttachChannelModel {
        return {
            type: TypeModel.ATTACH_CHANNEL,
            success: attachChannelResponse.payload.success
        };
    }
    public static mapStartConversationResponseToStartConversationModel(): StartConversationModel {
        return {
            type: TypeModel.START_CONVERSATION
        };
    }
}
